import {DOCUMENT} from '@angular/common';
import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import {GlobalSpinnerState} from './global-spinner.interface';

const initGlobalSpinnerState: GlobalSpinnerState = {
  isShown: false,
  loadingText: 'LOADER.LOADING'
};

@Injectable({
  providedIn: 'root'
})
export class GlobalSpinnerService {
  private renderer: Renderer2 | undefined;
  private state$: BehaviorSubject<GlobalSpinnerState> = new BehaviorSubject(initGlobalSpinnerState);
  numberOfOpenRequests = 0;

  constructor(@Inject(DOCUMENT) private document: Document, private rendererFactory: RendererFactory2) {
    this.initBodyElementChanges();
  }

  public get state(): Observable<GlobalSpinnerState> {
    return this.state$.asObservable();
  }

  public show(text?: string): void {
    this.numberOfOpenRequests++;
    this.state$.next({
      "loadingText": text || "",
      "isShown": true
    });
  }

  public reset(): void {
    if (this.numberOfOpenRequests > 0) {
      this.numberOfOpenRequests--;
    }
    if (this.numberOfOpenRequests == 0) {
      this.state$.next(initGlobalSpinnerState);
    }
  }

  private initBodyElementChanges(): void {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.state.subscribe(state => {
      if (state.isShown) {
        this.renderer?.addClass(this.document.body, 'vi-overflow-hidden');
      } else {
        this.renderer?.removeClass(this.document.body, 'vi-overflow-hidden');
      }
    });
  }
}
